import axios from 'axios'
import cookies from 'vue-cookies'

export default {
  namespaced: true,
  state: {
    chatAuth_token: null,
  },
  mutations: {},
  getters: {},
  actions: {
    POST_chatAuth({ rootState, rootGetters }) {
      return new Promise((resolve, reject) => {
        let config = {
          url: rootState.chatApiDomain + '/v1/auth/login',
          data: { token: cookies.get('token') },
          method: 'POST',
        }
        axios(config)
          .then((resp) => {
            cookies.set(
              'chat_token',
              resp.data,
              cookies.isKey('isSessionAuth') ? 0 : '1m',
              null,
              null,
              rootGetters.checkUseProtocol,
              'Strict',
            )
            resolve(resp.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
  },
}
